// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleFilledSvg from "@fishx/icons-svg/es/asn/PlusCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleFilledSvg
  }));
};

PlusCircleFilled.displayName = 'PlusCircleFilled';
export default React.forwardRef(PlusCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlusCircleFilled.js
// module id = 3809
// module chunks = 0